import SearchInput from '~/themes/base/components/shop/SearchInput'

export default {
  extends: SearchInput,
  mounted() {
    if (this.$themeSettings.components.SearchInput.clearOnLoad) {
      this.clearInput()
    }
  },
}
